import { createRoot } from "react-dom/client";
import { PatientApp } from "./patient";
import { registerServiceWorker } from "./patient/_shared/sw-register";

registerServiceWorker();

createRoot(document.getElementById("root")!).render(<PatientApp />);
